import { PostCardEdit } from './PostCardEdit';
export default PostCardEdit;
